import type { InitialPromptState } from "@/features/chat/useInitialPrompt";

/** Where to start a new chat in a space, optionally with an agent. */
export function newSpaceChatPath(spaceUuid: string, agentUuid?: string | null): string {
  const params = new URLSearchParams({ space: spaceUuid });
  if (agentUuid) params.set("agent", agentUuid);
  return `/chat?${params}`;
}

/** Navigation state that sends `prompt` as the new chat's first message. */
export function withPrompt(prompt: string | null | undefined): InitialPromptState | undefined {
  return prompt?.trim() ? { prompt: prompt.trim() } : undefined;
}

/** Navigation state that leaves `prompt` in the new chat's message box, for the user to finish and send. */
export function withPrefill(prompt: string | null | undefined): InitialPromptState | undefined {
  return prompt?.trim() ? { prefill: prompt.trim() } : undefined;
}
